import React from "react";

export interface IGreenBoxNumberProps {
    value: number
}

export const GreenBoxNumber = (props: IGreenBoxNumberProps) => {
    return (
        <span className="inline-flex items-center justify-center min-w-[24px] h-6 px-1.5
                         bg-accent-green text-white text-xs font-bold
                         rounded-full shadow-badge">
            {props.value}
        </span>
    )
}